
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTwowayStacked75 as ObiTwowayStacked75Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-twoway-stacked-75.js';
 
 
 

 
 export const ObiTwowayStacked75 = createComponent({
   react: React,
   tagName: 'obi-twoway-stacked-75',
   elementClass: ObiTwowayStacked75Element,
   events: {
     
   }
  });
 
 